import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';

class IpadAd extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    render() {
        const { content } = this.props;

        return <div dangerouslySetInnerHTML={{ __html: content }} />;
    }
}

export default errorBoundary(IpadAd);
